import React, { useEffect, useState } from "react";
import CustomerHeader from "../Common/CustomerHeader";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import showNotification from "../../services/redux/NotifcationService";
import { DetailsApi, updateDeclaration } from "../../services/redux/ApiActions";
import LogoDiv from "../Common/LogoDiv";
import Stepper from "../Common/Stepper";
import logo from "../../img/BBPS_Horizontal.png";

export default function StepFourDeclarationPartner() {
  const details = useSelector((state) => state.details.details);
  const customerData = useSelector((state) => state.customerData.customerData);

  const gstinResponse = JSON.parse(details?.result.gstinResponse);
  const [showLogo, setShowLogo] = useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  function formatDate(dateString) {
    const date = new Date(dateString);

    // Array of month names
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];

    // Get the month, day, year, hours, and minutes
    const month = months[date.getMonth()];
    const day = date.getDate();
    const year = date.getFullYear();
    const hours = date.getHours() % 12 || 12;
    const minutes = date.getMinutes();
    const period = date.getHours() < 12 ? "AM" : "PM";

    // Construct the formatted date string
    const formattedDate = `${month} ${day}, ${year} ${hours}:${minutes
      .toString()
      .padStart(2, "0")} ${period}`;

    return formattedDate;
  }

  const handleSubmit = async () => {
    const payload = {
      customerId: customerData?.custId,
      declarationSignedIp: "",
      declarationSignedUserAgent: "",
    };
    try {
      const data = await dispatch(
        updateDeclaration(payload, customerData?.token_chr)
      );
      if (data.statusCode === 200) {
        navigate("/Customer/Step5");
        showNotification("Declaration Updated Successfully", "success");
      }
    } catch (error) {
      showNotification(error, "error");
    }
  };
  const getDetails = async () => {
    // console.log(userAgent)
    const Payload = {
      id: customerData?.custId,
    };
    // console.log(Payload)
    const data = await dispatch(
      DetailsApi(Payload, customerData?.token_chr, "customer")
    );
    if (data?.result?.programId === 34 || data?.result?.programId === 35) {
      setShowLogo(false);
    } else {
      setShowLogo(true);
    }
  };

  useEffect(() => {
    getDetails();
  }, []);
  return (
    <>
      <body className="mailsentbody">
        <LogoDiv className="logoBG">
          <div className="rightElement">
            <CustomerHeader />
            <div className="grid mt-6 grid-cols-12 gap-4">
              <div className="col-span-12 md:col-span-2 lg:col-span-2"></div>
              <div className="col-span-12 md:col-span-8 lg:col-span-8 ">
                <Stepper />
                <div className="bg-white mx-2  shadow-xl p-3 mt-4 rounded-lg">
                  <div className="grid grid-cols-12 gap-4">
                    <div className="col-span-12 md:col-span-2 lg:col-span-2"></div>
                    <div className="col-span-12 md:col-span-8 lg:col-span-8">
                      <div className="py-2 text-center">
                        <h1 className="text-xl font-semibold letter-spacing">
                          DECLARATION
                        </h1>
                      </div>
                    </div>
                    <div className="col-span-12 md:col-span-2 lg:col-span-2">
                      {showLogo &&
                        {
                          /* <div
                          style={{
                            display: "flex",
                            justifyContent: "right",
                            marginTop: "-5px",
                          }}
                        >
                          <img src={logo} width={"100px"} height={"100px"} />
                        </div> */
                        }}
                    </div>
                  </div>
                  <div className="py-2 px-4">
                    <h1 className="text-md text-gray-600 declaration-css">
                      I certify that M/s.
                      <label className="font-bold underline">
                        {"    " + details?.result.customerName + "    "}
                      </label>
                      ({gstinResponse?.FullAddress}) is a{" "}
                      {details?.result.businessType} firm. and Mr. / Mrs.
                      <label className="font-bold underline">
                        {"    " + gstinResponse?.LegalName + "    "}
                      </label>
                      is proprietor / owner of the said Firm.
                    </h1>
                    <h1 className="text-md text-gray-600 declaration-css mt-4">
                      The PAN no of the Proprietorship firm is{" "}
                      <label className="font-bold underline">
                        {details?.result.pan}
                      </label>{" "}
                      which is in the name of aforesaid Proprietor.
                    </h1>
                  </div>
                  <div className="mt-4 col-span-12 md:col-span-7 lg:col-span-7">
                    <div className="relative text-center">
                      <button
                        onClick={handleSubmit}
                        disabled={
                          details?.result.declarationSigned !== null &&
                          details?.result.declarationSigned !== 1
                            ? true
                            : false
                        }
                        className="vtpRm-action-button"
                      >
                        {details?.result.declarationSigned !== null &&
                        details?.result.declarationSigned !== 1
                          ? `Declaration Signed at ${formatDate(
                              details?.result.declarationSignedAt
                            )}`
                          : "Confirm and Proceed"}
                      </button>
                      {details?.result.declarationSigned !== null &&
                      details?.result.declarationSigned !== 1 ? (
                        <>
                          <span
                            className="skip-btn hover:cursor-pointer py-4 px-4"
                            onClick={() => navigate("/Customer/Step5")}
                          >
                            Skip this step
                          </span>
                        </>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-span-12 md:col-span-2 lg:col-span-2"></div>
            </div>
          </div>
        </LogoDiv>
      </body>
    </>
  );
}
